import React, { useEffect, useState } from 'react';
import { useSeedanceAuthStore } from '../../../../store/seedanceAuthStore';
import { useSeedanceTaskStore } from '../../../../store/seedanceTaskStore';
import { Panel } from '../../../../store/seedanceTypes';
import './sidebar.css';

interface SidebarProps {
  panel: Panel;
  onSwitchPanel: (p: Panel) => void;
  onShowWelcome: () => void;
  onConnectAPI: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({
  panel,
  onSwitchPanel,
  onShowWelcome,
  onConnectAPI,
}) => {
  const fallbackVersion = process.env.REACT_APP_APP_DISPLAY_VERSION ?? '1.4';
  const [displayVersion, setDisplayVersion] = useState(fallbackVersion);

  useEffect(() => {
    const getAbout = (
      window as unknown as {
        electronAPI?: { getAbout?: () => Promise<{ displayVersion?: string }> };
      }
    ).electronAPI?.getAbout;
    void getAbout?.()
      ?.then((info) => {
        if (info?.displayVersion) setDisplayVersion(String(info.displayVersion));
      })
      .catch(() => {});
  }, []);

  const apiKey = useSeedanceAuthStore((s) => s.apiKey);
  const setApiKey = useSeedanceAuthStore((s) => s.setApiKey);
  const connected = useSeedanceAuthStore((s) => s.connected);

  const hasUnreadSucceeded = useSeedanceTaskStore((s) => s.hasUnreadSucceeded);
  const setHasUnreadSucceeded = useSeedanceTaskStore((s) => s.setHasUnreadSucceeded);

  return (
    <aside className="sidebar">
      <div className="logo">
        <div className="logo-icon">🎬</div>
        <div>
          <h1>首页科技</h1>
          <span>{`v${displayVersion} · 本地版`}</span>
        </div>
      </div>

      <div className="api-box">
        <input
          className="api-input"
          type="password"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          placeholder="粘贴 API Key…"
        />
        <button className="api-btn" onClick={onConnectAPI}>
          连接
        </button>
        <div className="api-status">
          <div className={`dot${connected ? ' on' : ''}`} />
          <span>{connected ? '已连接' : '未连接'}</span>
        </div>
        <div className="api-help">
          <a href="https://ai.k23.cn/" target="_blank" rel="noreferrer">
            注册并获取密钥
          </a>
        </div>
        <button className="api-settings-btn" onClick={onShowWelcome}>
          ⚙️ 重新配置 Key
        </button>
      </div>

      <nav className="nav">
        <button
          className={`nav-btn${panel === 'canvas' ? ' active' : ''}`}
          onClick={() => onSwitchPanel('canvas')}
        >
          <div className="nav-ico" style={{ background: 'rgba(139,92,246,.2)' }}>
            🎨
          </div>
          <span>创作工作台</span>
        </button>
        <button
          className={`nav-btn${panel === 'imageGen' ? ' active' : ''}`}
          onClick={() => onSwitchPanel('imageGen')}
        >
          <div className="nav-ico" style={{ background: 'rgba(59,111,212,.2)' }}>
            🖼️
          </div>
          <span>生成图像</span>
        </button>
        <button
          className={`nav-btn${panel === 'library' ? ' active' : ''}`}
          onClick={() => onSwitchPanel('library')}
        >
          <div className="nav-ico nav-ico--library">📦</div>
          <span>素材库</span>
        </button>
        <button
          className={`nav-btn${panel === 'tasks' ? ' active' : ''}`}
          onClick={() => {
            setHasUnreadSucceeded(false);
            onSwitchPanel('tasks');
          }}
        >
          <div className="nav-ico" style={{ background: 'rgba(16,185,129,.2)' }}>
            ⏳
          </div>
          <span>任务管理</span>
          {hasUnreadSucceeded && <span className="nav-unread-dot" aria-label="有新完成任务" />}
        </button>
        <button
          className={`nav-btn${panel === 'agreement' ? ' active' : ''}`}
          onClick={() => onSwitchPanel('agreement')}
        >
          <div className="nav-ico" style={{ background: 'rgba(107,114,128,.2)' }}>
            📄
          </div>
          <span>用户协议</span>
        </button>
      </nav>
    </aside>
  );
};
